// extracted by mini-css-extract-plugin
export default {"containerTopic":"topics_containerTopic__Uuqx6"};